import { Stack } from "@mui/material";
import { constraintAction } from "@pages/settings/subscription-settings/usage-metrics/constraint-tooltips";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /**
   * The type of the constraint to render.
   *
   * This value is used as a key in the `constraintAction` map
   * to determine which action component should be displayed.
   */
  constraintType: FaroCoreApiTypes.ConstraintQuotaIdentifier;

  /** The constraint data that will be passed */
  data: FaroCoreApiTypes.ConstraintQuota;
}

/** Renders the action associated with a given constraint type */
export function ConstraintAction({
  constraintType,
  data,
}: Props): JSX.Element | null {
  const Action = constraintAction[constraintType];

  if (!Action) {
    return null;
  }

  return (
    <Stack direction="row" gap={1} alignItems="center">
      {Action(data)}
    </Stack>
  );
}
